import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['template', 'container', 'item']
  static values = { max: Number }

  connect() {
    this.nextItemSequence = 0
    this.updateDeleteButtons()
  }

  add(event) {
    event.preventDefault()
    if (this.itemTargets.length >= this.maxValue) return

    const nextIndex = `new_${this.nextItemSequence}`
    this.nextItemSequence += 1
    const clone = this.templateTarget.innerHTML.replaceAll(
      '__INDEX__',
      nextIndex
    )
    this.containerTarget.insertAdjacentHTML('beforeend', clone)
    this.updateDeleteButtons()
  }

  remove(event) {
    event.preventDefault()
    if (this.itemTargets.length <= 1) return

    const item = event.currentTarget.closest(
      '[data-repeatable-cards-target="item"]'
    )

    if (item) {
      item.remove()
      this.updateDeleteButtons()
    }
  }

  updateDeleteButtons() {
    const hideDeleteButtons = this.itemTargets.length <= 1

    this.containerTarget
      .querySelectorAll('[data-repeatable-cards-delete-button]')
      .forEach((button) => {
        button.hidden = hideDeleteButtons
      })
  }
}
